import { useNuxtApp } from "#app";
const noop = {
  error: () => {
  },
  event: () => {
  }
};
export const useObservability = () => {
  const { $groundcover, $datadog } = useNuxtApp();
  if ($groundcover) {
    return {
      error: (error, attributes) => {
        const err = error instanceof Error ? error : new Error(String(error));
        $groundcover.captureException(err, attributes);
      },
      event: (name, attributes) => {
        $groundcover.sendCustomEvent({ event: name, attributes: attributes ?? {} });
      }
    };
  }
  if ($datadog) {
    return {
      error: (error, attributes) => {
        $datadog.addError(error, attributes);
      },
      event: (name, attributes) => {
        $datadog.addAction(name, attributes);
      }
    };
  }
  return noop;
};
